// 2025-05-03

import http from "./httpService";
import auth from "./authService";

const apiEndpoint = "/treinos/sessoes";
const user = auth.getCurrentUser();

export function getTreinos() {

  console.log("treino endpoint: " + apiEndpoint + "/user/" + user._id)

  if (!user) return null;

  return http.get(apiEndpoint + "/user/" + user._id);
}
